<div class="upsell-why">
  <div class="upsell-why__container mx-auto">
    <div class="upsell-why__wrapper p-4 w-full">
      <div class="upsell-why__questions">
        <div *ngFor="let item of upsellWhyContent; trackBy: trackByFn" class="upsell-why__item mb-6">
          <p class="upsell-why__question text-xl font-medium text-bhmd-blue" [innerHTML]="item.question"></p>
          <div class="upsell-why__separator w-8 h-px bg-black -mt-1"></div>
          <p class="upsell-why__answer" [innerHTML]="item.answer"></p>
        </div>
      </div>
    </div>
  </div>
</div> 